export enum PartQualityEnum {
	Original = "original",
	Iam = "iam",
	Used = "used",
	Other = "other",
}

export interface IPartOffer {
	idPartLine: string;
	guidPart: string;
	partName: string;
	categoryName: string;
	subCategoryName: string;
	isAvailable: boolean;
	supplierName: string;
	guidSupplier: string;
	idPartType: number;
	partTypeName: string;
	quality: PartQualityEnum;
	price: number;
	shippingCost: number;
	deliveryDays: number;
	deliveryBySupplier: boolean;
	guidQuoteItem: string;
	guidQuoteSupplierItem: string;
	guidSupplierInventoryWarehouse: string;
}

export interface ISummaryData {
	offers: IPartOffer[];
}
